import { Box, Typography } from '@mui/material'

export const SummaryTrackingCards = (): JSX.Element => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant='body2' sx={{ color: 'var(--grey-500)', fontStyle: 'italic' }}>
        Tracking progress cards are only available in the live survey view.
      </Typography>
    </Box>
  )
}
